import styled from 'styled-components';

const StyledIcon = styled.img`
  width: ${({ width, size }) => width || size || '24px'};
  height: ${({ height, size }) => height || size || '24px'};
`;

const Icon = ({ src, size, width, height }) => {
  return <StyledIcon src={src} size={size} width={width} height={height} alt="icon" />;
};

export default Icon;